module.exports = __webpack_public_path__ + "img/4_wgoods.f15b3fd4.jpg";